import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from "@material-ui/core/Typography";
 
class TransactionHistory extends Component {
    state = {
        captchaTextVal: false
    }
 
   render() {
    const { transactions, transactionLoading } = this.props;
       return (<div>
          {
            transactionLoading ?
            <Typography align="center" variant='subtitle1' ><CircularProgress size={30} thickness={4} style={{color: '#F29900', marginTop: '20px'}} /></Typography>
            :
            transactions.length >0 && transactions.map((transaction, i) => (
                <div>
                    <div className='listTransactions'>
                        <div className='leftBox'>
                            <b>{transaction['mode_of_payment']}</b>
                            <br></br>
                            {transaction['redeem_amount']}
                        </div>
                        <div className='middleBox'></div>
                        <div className='rightBox'>
                            {transaction['date_time'].split(' ')[0]}
                            <br></br>
                            {transaction['date_time'].split(' ')[1]}
                        </div> 
                    </div>
                    <br></br>
                </div>
            ))
            }
       </div>);
   };
}
 
export default TransactionHistory;